"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CTEGenerator", {
    enumerable: true,
    get: function() {
        return CTEGenerator;
    }
});
const _baseusergeneralcte = require("~/db/cte-generator/base-user.general.cte");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CLIENT_DEFAULT = '_default';
let CTEGenerator = class CTEGenerator {
    getCteModules(moduleName, clientType) {
        var _this_cteModules_moduleName_clientType;
        const cteModuleClass = (_this_cteModules_moduleName_clientType = this.cteModules[moduleName][clientType]) != null ? _this_cteModules_moduleName_clientType : this.cteModules[moduleName][CLIENT_DEFAULT];
        return new cteModuleClass(clientType);
    }
    async getClientType() {
        if (this.clientType) {
            return this.clientType;
        }
        const base = await _models.Base.get(this.info.context, this.info.context.base_id);
        const sources = await base.getSources();
        const source = sources[0];
        this.clientType = source.type;
        return this.clientType;
    }
    getExistingAlias(alias) {
        return this.blocks.get(alias);
    }
    async baseUser(param) {
        const cteBlock = await this.getCteModules('baseUser', await this.getClientType()).inquiry(_extends({
            context: this.info.context
        }, param), this);
        this.blocks.set(cteBlock.alias, cteBlock);
        return cteBlock;
    }
    customCte(cteBlock) {
        this.blocks.set(cteBlock.alias, cteBlock);
        return cteBlock;
    }
    applyCte(qb) {
        for (const [_alias, block] of this.blocks.entries()){
            block.applyCte(qb, this.info);
        }
    }
    clear() {
        this.blocks.clear();
    }
    constructor(info){
        this.info = info;
        this.cteModules = {
            baseUser: {
                [CLIENT_DEFAULT]: _baseusergeneralcte.BaseUserGeneralCte
            }
        };
        this.blocks = new Map();
    }
};
